module.exports = __webpack_public_path__ + "static/media/dominik2.2486422b.jpg";